/** 全局 IconFont <IconFont type='icon名称' /> */
import { createFromIconfontCN } from '@ant-design/icons';

const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2420044_v2p1wmqogz.js',
});

export default IconFont;
